import React, { useEffect } from "react";
import { Text, Flex } from "@chakra-ui/react";
import Image from "next/image";
import { Link } from "components/Link";
import { useSegment } from "tracking";
import { useInView } from "react-intersection-observer";
import { dispatch } from "@shared/utils.events";
import { fonts } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const QuizEntry: React.FC = () => {
  const { track } = useSegment();

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 1
  });

  useEffect(() => {
    if (inView) {
      dispatch("page element viewed", {
        target: "PDP Quiz",
        details: "Get great skin! Take our quiz..."
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <Flex
      alignItems="center"
      data-testid="quiz-entry"
      mt={{ base: "40px", lg: "80px" }}
      py="auto"
      bgColor={colours.accent.light}
    >
      <Image
        src="/images/search/quiz-insert.jpg"
        alt="Take our skincare quiz!"
        width="112"
        height="112"
      />
      <Flex
        direction={{ base: "column", lg: "row" }}
        justifyContent="space-between"
        mx={{ base: "16px", lg: "40px" }}
        w="-webkit-fill-available"
      >
        <Flex direction="column">
          <Text
            display={{ base: "none", lg: "block" }}
            mt={0}
            fontFamily={fonts.demi}
            fontWeight={500}
            fontSize="16px"
            lineHeight="24px"
            letterSpacing="10%"
            textTransform="uppercase"
            pb={-1}
            alignSelf="flex-start"
          >
            Get Glowing!
          </Text>
          <Text
            fontFamily={fonts.acuminLight}
            mt={0}
            pb={{ base: "8px", lg: "0" }}
          >
            Find the products that will work magic on your skin.
          </Text>
        </Flex>
        <Link
          href="/quiz/skincare"
          ref={ref}
          id="skin-quiz"
          target="_blank"
          fontFamily={fonts.acuminMedium}
          fontWeight={500}
          minWidth="100px"
          alignSelf={{ base: "flex-start", lg: "flex-end" }}
          textDecoration="underline"
          onClick={() => {
            track({
              event: "Page Element Clicked",
              properties: {
                module_content:
                  "Take our quiz to find out which skincare kit is perfect for you."
              }
            });
          }}
          scrollMarginTop={{ base: "120px", lg: "200px" }}
        >
          Take The Quiz
        </Link>
      </Flex>
    </Flex>
  );
};
